import styles from "./RefineWithAIButton.module.css";

type Props = {
  label: string;
  onClick: () => void;
  variant?: "blue" | "primary";
  className?: string;
  disabled?: boolean;
};

const RefineWithAIButton = ({ label, onClick, variant = "primary", className, disabled = false }: Props) => {
  const variantClass = variant === "primary" ? styles["gradient-primary"] : styles["gradient-blue"];

  return (
    <button
      type="button"
      className={`inline-flex relative gap-1 justify-center items-center px-3 w-full h-10 bg-white rounded-[6px] shrink-0 text-label3 ${styles["gradient-border-spin"]} ${variantClass} ${className ?? ""} ${disabled ? "opacity-50 pointer-events-none" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        className="shrink-0"
        aria-hidden="true"
      >
        <path
          d="M12 5.33333L12.8333 3.5L14.6667 2.66667L12.8333 1.83333L12 0L11.1667 1.83333L9.33333 2.66667L11.1667 3.5L12 5.33333Z"
          fill="url(#paint0_linear_4972_1305)"
        />
        <path
          d="M12 9.33333L11.1667 11.1667L9.33333 12L11.1667 12.8333L12 14.6667L12.8333 12.8333L14.6667 12L12.8333 11.1667L12 9.33333Z"
          fill="url(#paint1_linear_4972_1305)"
        />
        <path
          d="M7 5.66667L5.33333 2L3.66667 5.66667L0 7.33333L3.66667 9L5.33333 12.6667L7 9L10.6667 7.33333L7 5.66667ZM5.99333 7.99333L5.33333 9.44667L4.67333 7.99333L3.22 7.33333L4.67333 6.67333L5.33333 5.22L5.99333 6.67333L7.44667 7.33333L5.99333 7.99333Z"
          fill="url(#paint2_linear_4972_1305)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4972_1305"
            x1="0"
            y1="7.33333"
            x2="14.6667"
            y2="7.33333"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3BFF" />
            <stop offset="0.380208" stopColor="#ECBFBF" />
            <stop offset="1" stopColor="#D94FD5" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4972_1305"
            x1="0"
            y1="7.33333"
            x2="14.6667"
            y2="7.33333"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3BFF" />
            <stop offset="0.380208" stopColor="#ECBFBF" />
            <stop offset="1" stopColor="#D94FD5" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_4972_1305"
            x1="0"
            y1="7.33333"
            x2="14.6667"
            y2="7.33333"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3BFF" />
            <stop offset="0.380208" stopColor="#ECBFBF" />
            <stop offset="1" stopColor="#D94FD5" />
          </linearGradient>
        </defs>
      </svg>
      <span className={styles["gradient-text"]}>{label}</span>
    </button>
  );
};

export default RefineWithAIButton;
